import { useState } from "react";
import type { AnalysisChapter } from "@/types/content";

export default function AnalysisTabs({ chapters }: { chapters: AnalysisChapter[] }) {
  const [active, setActive] = useState(0);
  const chapter = chapters[active];

  if (!chapter) return null;

  return (
    <div className="rounded-lg border border-background-200 bg-background-50">
      <div className="flex flex-col divide-y divide-background-200 border-b border-background-200 sm:flex-row sm:divide-x sm:divide-y-0">
        {chapters.map((item, index) => (
          <button
            key={item.title}
            type="button"
            onClick={() => setActive(index)}
            className={`relative flex flex-1 items-center justify-center gap-2 px-4 py-3 text-xs font-medium transition-colors whitespace-nowrap sm:text-sm ${
              index === active
                ? "bg-primary-50 text-primary-800"
                : "text-foreground-600 hover:bg-background-100 hover:text-primary-700"
            }`}
            aria-pressed={index === active}
          >
            <span
              className={`font-label text-[11px] font-bold ${
                index === active ? "text-accent-600" : "text-foreground-400"
              }`}
            >
              {String(index + 1).padStart(2, "0")}
            </span>
            {item.title.replace(/^第.章 · /, "")}
            {index === active && <span className="absolute inset-x-0 bottom-0 h-0.5 bg-accent-500 sm:hidden" />}
          </button>
        ))}
      </div>
      <div key={chapter.title} className="animate-fade-in px-5 py-6 md:px-7 md:py-8">
        <h4 className="font-heading text-lg font-bold text-foreground-950">{chapter.title}</h4>
        <div className="mt-4 flex flex-col gap-4">
          {chapter.paragraphs.map((paragraph) => (
            <p key={paragraph.slice(0, 18)} className="text-sm leading-8 text-foreground-700 md:text-[15px]">
              {paragraph}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
}